import { useEffect, useState } from "react";
import { api } from "../lib/api";
export function AuditHistoryPanel({ caseId }) {
    const [items, setItems] = useState([]);
    const [error, setError] = useState(null);
    useEffect(() => {
        api
            .get(`/cases/${caseId}/audit-log`)
            .then((r) => setItems(r.items))
            .catch(() => setError("Couldn't load audit history."));
    }, [caseId]);
    if (error)
        return <div style={{ color: "var(--st-risk)", fontSize: "0.85rem" }}>{error}</div>;
    return (<div>
      {items.map((entry) => (<div className="lg-pair" key={entry.id} style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr 1fr 2fr", gap: 8, padding: "9px 0", borderTop: "1px solid var(--line-soft)", fontSize: "0.8rem" }}>
          <div className="mono" style={{ color: "var(--ink-faint)" }}>
            {new Date(entry.occurredAt).toLocaleString()}
          </div>
          <div className="mono" style={{ color: "var(--accent-ink)" }}>
            {entry.collectionName.replace(/^legal_/, "").replace(/_/g, " ")}
          </div>
          <div>{entry.actorName}</div>
          <div style={{ color: "var(--ink-soft)" }}>{entry.action.replace(/_/g, " ")}</div>
        </div>))}
      {items.length === 0 && !error && <div style={{ color: "var(--ink-faint)", fontSize: "0.85rem" }}>No audited changes recorded for this case yet.</div>}
    </div>);
}
